import { FC } from "react";

import { useTranslation } from "react-i18next";

import { getDocumentOwnerNames, getInitials } from "@utils";

import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

import { IDocumentDetailsProperties } from "./DocumentDetails.types";

const DocumentDetails: FC<IDocumentDetailsProperties> = ({ document }) => {
  const { t } = useTranslation();

  const ownerNames = getDocumentOwnerNames(document);

  return (
    <>
      {ownerNames.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {ownerNames.map((ownerName) => (
            <Chip
              key={ownerName}
              data-amp-mask={true}
              avatar={<Avatar>{getInitials(ownerName)}</Avatar>}
              label={ownerName}
              sx={{
                "& .MuiChip-avatar": {
                  bgcolor: "secondary.main",
                  color: "secondary.contrastText",
                  fontSize: "0.75rem",
                  fontWeight: 500,
                },
              }}
            />
          ))}
        </Box>
      )}
      {document.caseNumber != null && (
        <Typography variant="body2" color="text.secondary">
          {t("cartSidebar.caseNumber", { caseNumber: document.caseNumber })}
        </Typography>
      )}
    </>
  );
};

export default DocumentDetails;
